import axiosInstance from "../../translator";
import {
  machineCatalogueAPI as machineCatalog,
  resourceManagerAPI as resourceManager,
} from "../../constants/apis/apiEndpoints";
import axios from "axios";
import { customCloudProviderHeader } from "../../constants/componentConstants";
import { translator } from "../../constants/actionTypes";

export const fetchCatalogsList = async (urlParams) => {
  return axiosInstance
    .get(`${machineCatalog?.catalogues}${urlParams}`)
    .then((response) => {
      return response?.data;
    })
    .catch((error) => {
      return error;
    });
};

export const deleteCatalog = async (id) => {
  return axiosInstance
    .delete(`${machineCatalog?.catalogues}/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const changeStatusApi = async (data) => {
  return axiosInstance
    .patch(`${machineCatalog?.catalogues}/${data.id}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const createCloneApi = async (data) => {
  return axiosInstance
    .post(`${machineCatalog?.catalogue_master}/clone`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const cloneApi = async (data) => {
  return axiosInstance
    .post(`${machineCatalog?.catalogues}/clone`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const listCloudTemplateRequest = async (urlParams) => {
  return axios
    .get(
      `${translator.baseURL}${resourceManager?.cloudTemplate}${urlParams}`,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
};
export const getCloudTemplateByIdRequest = async (id) => {
  return axios
    .get(
      `${translator.baseURL}${resourceManager?.cloudTemplate}/${id}`,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const createCloudBatchRequest = async (data) => {
  return axios
    .post(
      `${translator.baseURL}${machineCatalog?.cloudBatch}`,
      data,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const updateCloudBatchRequest = async (payload) => {
  return axios
    .put(
      `${translator.baseURL}${machineCatalog?.cloudBatch}/${payload?.id}`,
      payload?.payload,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const patchCloudBatchRequest = async (payload) => {
  return axios
    .patch(
      `${translator.baseURL}${machineCatalog?.cloudBatch}/${payload?.id}`,
      payload?.payload,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const deleteCloudBatchRequest = async (id) => {
  return axios
    .delete(
      `${translator.baseURL}${machineCatalog?.cloudBatch}/${id}`,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const listCloudBatchRequest = async (urlParams) => {
  return axios
    .get(
      `${translator.baseURL}${machineCatalog?.cloudBatch}${urlParams}`,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const workspaceBatchTenantListApi = async (urlParams) => {
  return axios
    .get(
      `${translator.baseURL}${machineCatalog.workspaceBatchTenantList}${urlParams}`,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const generateWorkspaceReportApi = async (payload) => {
  return axios
    .post(
      `${translator.baseURL}${machineCatalog.workspaceBatchReports}`,
      payload,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const workspaceCloudBatchReportsListApi = async (urlParams) => {
  return axios
    .get(
      `${translator.baseURL}${machineCatalog.workspaceBatchReports}${urlParams}`,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const listCloudLabRequest = async (urlParams) => {
  return axios
    .get(
      `${translator.baseURL}${machineCatalog?.cloudLab}${urlParams}`,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};
export const deleteCloudLabRequest = async (id) => {
  return axios
    .delete(
      `${translator.baseURL}${machineCatalog?.cloudLab}/${id}`,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const createCloudLabRequest = async (data) => {
  return axios
    .post(
      `${translator.baseURL}${machineCatalog?.cloudLab}`,
      data,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const getCloudLabByIdRequest = async (params) => {
  return axios
    .get(
      `${translator.baseURL}${machineCatalog?.cloudLab}/${params?.id}${params?.params}`,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const retrieveCloudBatchByIdRequest = async (id) => {
  return axios
    .get(
      `${translator.baseURL}${machineCatalog?.cloudBatch}/${id}`,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const retrieveCloudWorkspaceBatchByIdRequest = async (id) => {
  return axios
    .get(
      `${translator.baseURL}${machineCatalog?.cloudBatch}/${id}`,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const createCloudLabFeedbackRequest = async (data) => {
  return axios
    .post(
      `${translator.baseURL}${machineCatalog?.cloudLabFeedback}`,
      data,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const updateCloudLabFeedbackRequest = async (data) => {
  return axios
    .put(
      `${translator.baseURL}${machineCatalog?.cloudLabFeedback}/${data?.id}`,
      data?.payload,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
export const patchCloudLabFeedbackRequest = async (data) => {
  return axios
    .patch(
      `${translator.baseURL}${machineCatalog?.cloudLabFeedback}/${data?.id}`,
      data?.payload,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const deleteCloudLabFeedbackRequest = async (id) => {
  return axios
    .delete(
      `${translator.baseURL}${machineCatalog?.cloudLabFeedback}/${id}`,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const listCloudLabFeedbackRequest = async () => {
  return axios
    .get(
      `${translator.baseURL}${machineCatalog?.cloudLabFeedback}`,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const retrieveCloudLabFeedbackRequest = async (id) => {
  return axios
    .get(
      `${translator.baseURL}${machineCatalog?.cloudLabFeedback}/${id}`,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const createCloudLabExtensionRequest = async (data) => {
  return axios
    .post(
      `${translator.baseURL}${machineCatalog?.cloudLabExtension}`,
      data,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const getCloudLabExtensionRequest = async () => {
  return axios
    .get(
      `${translator.baseURL}${machineCatalog?.cloudLabExtension}`,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const retrieveCloudLabExtensionRequest = async (id) => {
  return axios
    .get(
      `${translator.baseURL}${machineCatalog?.cloudLabExtension}/${id}`,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const createCloudBatchExtensionRequest = async (data) => {
  return axios
    .post(
      `${translator.baseURL}${machineCatalog?.cloudBatchExtension}`,
      data,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const retrieveCloudLabAwsRequest = async (params) => {
  return axios
    .get(
      `${translator.baseURL}${machineCatalog?.cloudLabAws}/${params?.id}`,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const listCloudTemplateTenantRequest = async (params) => {
  return axios
    .get(
      `${translator.baseURL}${machineCatalog?.cloudTemplateTenant}${params}`,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const createCloudTemplateTenantRequest = async (data) => {
  return axios
    .post(
      `${translator.baseURL}${machineCatalog?.cloudTemplateTenant}`,
      data,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const updateCloudTemplateTenantRequest = async (params) => {
  return axios
    .put(
      `${translator.baseURL}${machineCatalog?.cloudTemplateTenant}/${params?.id}`,
      params?.payload,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const patchCloudTemplateTenantRequest = async (params) => {
  return axios
    .patch(
      `${translator.baseURL}${machineCatalog?.cloudTemplateTenant}/${params?.id}`,
      params?.data,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const deleteCloudTemplateTenantRequest = async (params) => {
  return axios
    .delete(
      `${translator.baseURL}${machineCatalog?.cloudTemplateTenant}/${params}`,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const retrieveByIdCloudTemplateTenantRequest = async (params) => {
  return axios
    .get(
      `${translator.baseURL}${machineCatalog?.cloudTemplateTenant}/${params}`,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const retrieveCloudLabCredential = async (data) => {
  return axios
    .get(
      `${translator.baseURL}${data?.apiEndPoint}/${data?.id}`,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const exportCatalogApi = async (id) => {
  return axiosInstance
    .get(`${machineCatalog?.catalogExport}?catalogue_id=${id}`)
    .then((response) => {
      return response?.data;
    })
    .catch((error) => {
      return error;
    });
};

export const createCatalogPlanMapApi = async (data) => {
  return axiosInstance
    .post(`${machineCatalog?.planMapping}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const updateCatalogPlanMapApi = async (id, data) => {
  return axiosInstance
    .put(`${machineCatalog?.planMapping}/${id}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const retriveCatalogPlanMapApi = async (urlParams) => {
  return axiosInstance
    .get(`${machineCatalog?.planMapping}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const markCatalogForB2cApi = async (id, data) => {
  return axiosInstance
    .patch(`${machineCatalog?.catalogues}/${id}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const cloudLabReProvisionRequest = async (id) => {
  return axios
    .get(
      `${translator.baseURL}${machineCatalog?.reProvision}/${id}`,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};

export const updatePermissionPolicyRequest = async (id, data) => {
  return axios
    .put(
      `${translator.baseURL}${machineCatalog?.updatePolicy}/${id}`,
      data,
      customCloudProviderHeader()
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
};
